import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state: {
    // 警报点管理模块
    alarmPointID1:'',//用于摄像头保存警报点ID
    alarmPointId:'', // 警报点ID
    pointName:'', // 警报点名称
    // 告警管理模块
    alarmRecordId:'', // 告警记录详情
    lastRouter:'',// 主页面最后一个访问的页面
    token:'',
    AlarmPointStaticInfomation:'',
    alarmPointTypes:'',
    userInfo:"",
    isFullScreen: true,
  },
  mutations: {
    setUserInfo(state, value){
      state.userInfo = value;
    },
    setAlarmPointTypes(state, value){
      state.alarmPointTypes = value;
    },
    setAlarmPointStaticInfomation(state, value){
      state.AlarmPointStaticInfomation = value
    },
    setAlarmPointId(state,value){
      state.alarmPointId = value;
    },
    setPointName(state,value){
      state.pointName = value;
    },
    setAlarmRecordId(state, value){
      state.alarmRecordId = value;
    },
    setLastRouter(state, value){
      state.lastRouter = value;
    },
    setToken(state, value){
      state.token = value;
    },
    setAlarmPointID1(state,value){
      state.alarmPointID1 = value;
    }
  },
  actions: {

  }
})
